document.addEventListener('click', (event) => {
  const optionButton = event.target.closest('[data-option-value]');
  if (!optionButton) return;

  const form = optionButton.closest('form');
  const variantData = form && form.querySelector('[data-variant-json]');
  const idInput = form && form.querySelector('input[name="id"]');
  const addButton = form && form.querySelector('[data-add-to-bag]');
  const priceElement = document.querySelector('[data-product-price]');
  if (!variantData || !idInput) return;

  const group = optionButton.closest('[data-option-index]');
  const optionIndex = Number(group.dataset.optionIndex);
  form.querySelectorAll(`[data-option-index="${optionIndex}"] [data-option-value]`).forEach((button) => {
    button.setAttribute('aria-pressed', button === optionButton ? 'true' : 'false');
  });
  const selectedValueLabel = group.querySelector('[data-selected-option-value]');
  if (selectedValueLabel) selectedValueLabel.textContent = optionButton.dataset.optionValue;

  const selectedOptions = [];
  form.querySelectorAll('[data-option-index]').forEach((optionGroup) => {
    const pressed = optionGroup.querySelector('[aria-pressed="true"]');
    selectedOptions[Number(optionGroup.dataset.optionIndex)] = pressed ? pressed.dataset.optionValue : null;
  });

  const variants = JSON.parse(variantData.textContent);
  const selectedVariant = variants.find((variant) => {
    return variant.options.every((value, index) => value === selectedOptions[index]);
  });

  if (!selectedVariant) return;
  idInput.value = selectedVariant.id;
  if (priceElement) {
    priceElement.textContent = formatMoney(selectedVariant.price);
  }
  if (addButton) {
    addButton.disabled = !selectedVariant.available;
    addButton.textContent = selectedVariant.available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
  }
});

function formatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
}
